import React from 'react';
import { Container, Header, Segment, Divider, List, Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <Container text>
      <Segment raised>
        <Header as="h1" textAlign="center">
          {t('PrivacyPolicy')}
        </Header>

        <Divider />

        <Header as="h2">1. {t('PrivacyPolicy_Intro_Title')}</Header>
        <p>
          {t('PrivacyPolicy_Intro')}
        </p>

        <Header as="h2">2. {t('PrivacyPolicy_DataCollection_Title')}</Header>
        <p>
          {t('PrivacyPolicy_DataCollection_Intro')}
        </p>
        <List bulleted>
          <List.Item>{t('PrivacyPolicy_DataCollection_List1')}</List.Item>
          <List.Item>{t('PrivacyPolicy_DataCollection_List2')}</List.Item>
          <List.Item>{t('PrivacyPolicy_DataCollection_List3')}</List.Item>
          <List.Item>{t('PrivacyPolicy_DataCollection_List4')}</List.Item>
          <List.Item>{t('PrivacyPolicy_DataCollection_List5')}</List.Item>
          <List.Item>{t('PrivacyPolicy_DataCollection_List6')}</List.Item>
          <List.Item>{t('PrivacyPolicy_DataCollection_List7')}</List.Item>
        </List>
        <p>
          {t('PrivacyPolicy_DataCollection_Para')}
        </p>

        <Header as="h2">3. {t('PrivacyPolicy_UseOfData_Title')}</Header>
        <p>
          {t('PrivacyPolicy_UseOfData_Intro')}
        </p>
        <List bulleted>
          <List.Item>{t('PrivacyPolicy_UseOfData_List1')}</List.Item>
          <List.Item>{t('PrivacyPolicy_UseOfData_List2')}</List.Item>
          <List.Item>{t('PrivacyPolicy_UseOfData_List3')}</List.Item>
          <List.Item>{t('PrivacyPolicy_UseOfData_List4')}</List.Item>
          <List.Item>{t('PrivacyPolicy_UseOfData_List5')}</List.Item>
          <List.Item>{t('PrivacyPolicy_UseOfData_List6')}</List.Item>
        </List>

        <Header as="h2">4. {t('PrivacyPolicy_SharingOfData_Title')}</Header>
        <p>
          {t('PrivacyPolicy_SharingOfData_Intro')}
        </p>
        <List bulleted>
          <List.Item>{t('PrivacyPolicy_SharingOfData_List1')}</List.Item>
          <List.Item>{t('PrivacyPolicy_SharingOfData_List2')}</List.Item>
          <List.Item>{t('PrivacyPolicy_SharingOfData_List3')}</List.Item>
          <List.Item>{t('PrivacyPolicy_SharingOfData_List4')}</List.Item>
        </List>

        <Header as="h2">5. {t('PrivacyPolicy_Security_Title')}</Header>
        <p>
          {t('PrivacyPolicy_Security')}
        </p>

        <Header as="h2">6. {t('PrivacyPolicy_Cookies_Title')}</Header>
        <p>
          {t('PrivacyPolicy_Cookies')}
        </p>

        <Header as="h2">7. {t('PrivacyPolicy_UserRights_Title')}</Header>
        <p>
          {t('PrivacyPolicy_UserRights_Intro')}
        </p>
        <List bulleted>
          <List.Item>{t('PrivacyPolicy_UserRights_List1')}</List.Item>
          <List.Item>{t('PrivacyPolicy_UserRights_List2')}</List.Item>
          <List.Item>{t('PrivacyPolicy_UserRights_List3')}</List.Item>
          <List.Item>{t('PrivacyPolicy_UserRights_List4')}</List.Item>
        </List>
        <p>
          {t('PrivacyPolicy_UserRights_Para')}
        </p>

        <Header as="h2">8. {t('PrivacyPolicy_Changes_Title')}</Header>
        <p>
          {t('PrivacyPolicy_Changes')}
        </p>

        <Header as="h2">9. {t('PrivacyPolicy_Contact_Title')}</Header>
        <p>
          {t('PrivacyPolicy_Contact_Intro')}
        </p>
        <p>
          <strong>{t('PrivacyPolicy_Contact_Email_Label')}</strong>{' '}
          <a href="mailto:contact@fablia.fr">contact@fablia.fr</a>
        </p>
      </Segment>
    </Container>
  );
};

export default PrivacyPolicy;
